export class Location {
    ipAddress!: string;
    city!: string;
    country!: string;
    countryCode!: string;
    latitude!: number;
    longitude!: number;
    continent!: string;
    continentCode!: string;
    regionName!: string;
    regionPrefix!: string;
}